// "/" sends the user to the right place based on their session.
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { homeFor } from "../lib/nav";
import { FullScreenLoader } from "../components/Loader";

export function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user.role)} replace />;
}
